export const getFirstAllowedRoute = (permissions) => {
  if (permissions.users) return "/users";
  if (permissions.promoters) return "/promoters";
  if (permissions.user_types) return "/user-types";

  return "/no-access";
};
